<template>
	<ul>
		<li v-bind:value="value" v-on:click="updateValue('main')"><router-link id="home" to="/home">Home</router-link></li>
		<li v-bind:value="value" v-on:click="updateValue('hiring')"><router-link id="hiring" to="/hiring">Hiring?</router-link></li>
		<!--<li v-bind:value="value" v-on:click="updateValue('contact')"><router-link id="contact" to="/contact">Contact</router-link></li>-->
	</ul>
</template>

<script>
	export default {
		name: 'MainNav',
		props: ['value'],
		methods: {
			updateValue: function (value) {
				this.$emit('input', value);
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	ul {
		list-style-type: none;
		padding: 0;
	}
	li {
		display: inline-block;
		margin: 0 10px;
	}
</style>
